// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"b78f88a4","128":"b78f88a4","212":"b78f88a4","691":"b78f88a4"}[chunkId] + ".chunk.css";
};